module.exports = __webpack_public_path__ + "img/account-zip.d8e29a76.svg";